<template>
  <span>
    <span v-if="accred_comps.suspended" class="tag is-outlined is-danger">
      <span v-text="$t('Аттестат приостановлен')"></span>
    </span>
    <span v-else-if="isAcredentialled" class="tag is-outlined is-success">
      <span v-text="$t('Обследован до')"></span>
      <span>&nbsp;</span>
      <ws-time-formatter :date="expiresAt" />
    </span>
    <span v-else class="tag is-outlined is-danger">
      <span v-text="$t('Не обследован')"></span>
    </span>
  </span>
</template>
<script>
import { isDeCenterAccredited } from '@/utils/isDeCenterAccreditated'
import { toUTCDay } from '@/utils/helpers'
export default {
  name: 'WsAccreditation',
  props: {
    accred_comps: {
      type: Object
    },
    exam: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {}
  },
  computed: {
    isAcredentialled () {
      const flags = this.exam ? this.exam.flags : undefined
      return isDeCenterAccredited(this.accred_comps, flags)
    },
    expiresAt () {
      return toUTCDay(new Date(this.accred_comps.expires_at)).toISOString()
    }
  }
}
</script>
